import {
  ADD_STUDENT_CSV,
  BASE_URL,
  LIST_STUDENTS,
  LIST_BALANCE,
  STUDENT,
  STUDENT_STATS,
  GET_STUDENT_BALANCE,
  STUDENT_CURENT_INVOICE,
  STUDENT_INVOICES,
  UPLOAD_STUDENT_PROFILE_PIC,
  GET_STUDENT_TRANSACTIONS,
  UPDATE_STUDENT_CSV,
} from "../util/constants";
import { sendRequest } from "./base";
import axios from "axios";

export const getAllStudents = async (page, token, limit) => {
  const Authorization = `Bearer ${token}`;
  //alert();
  try {
    return sendRequest(
      null,
      "GET",
      `${LIST_STUDENTS}?page=${page + 1}&pageSize=${limit}`,
      { Authorization }
    );
  } catch (err) {
    return err;
  }
};
export const getBalance = async (page, token, limit) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(
      null,
      "GET",
      `${LIST_BALANCE}?page=${page + 1}&pageSize=${limit}`,
      { Authorization }
    );
  } catch (err) {
    return err;
  }
};

export const getStudents = async (token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(null, "GET", `${LIST_STUDENTS}?all=${true}`, {
      Authorization,
    });
  } catch (err) {
    return err;
  }
};

export const getStudentParent = async (token, studentIds) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(
      null,
      "GET",
      `${LIST_STUDENTS}?studentIds=${studentIds}`,
      {
        Authorization,
      }
    );
  } catch (err) {
    return err;
  }
};

export const addStudent = async (data, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(data, "POST", STUDENT, { Authorization });
  } catch (err) {
    return err;
  }
};

export const getStudentStats = async (data, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(data, "POST", STUDENT_STATS, { Authorization });
  } catch (err) {
    return err;
  }
};

export const viewStudent = async (studentId, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(null, "GET", `${STUDENT}?studentId=${studentId}`, {
      Authorization,
    });
  } catch (err) {
    return err;
  }
};

export const updateStudent = async (studentId, data, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(data, "PUT", `${STUDENT}/?studentId=${studentId}`, {
      Authorization,
    });
  } catch (err) {
    return err;
  }
};

export const filterByGrade = async (grade, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(null, "GET", `${STUDENT}/all?grade=${grade}`, {
      Authorization,
    });
  } catch (err) {
    return err;
  }
};

export const filterByDate = async (fromDate, toDate, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(
      null,
      "GET",
      `${STUDENT}/all?fromDate=${fromDate}&toDate=${toDate}`,
      {
        Authorization,
      }
    );
  } catch (err) {
    return err;
  }
};

export const FilterSearchBy = async (searchBy, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(null, "GET", `${STUDENT}/all?searchBy=${searchBy}`, {
      Authorization,
    });
  } catch (err) {
    return err;
  }
};

export const deleteStudent = async (studentId, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(null, "DELETE", `${STUDENT}/?studentId=${studentId}`, {
      Authorization,
    });
  } catch (err) {
    return err;
  }
};
export const deleteStudents = async (selectedIds, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(
      { data: selectedIds },
      "DELETE",
      `${STUDENT}/deleteAll`,
      {
        Authorization,
      }
    );
  } catch (err) {
    return err;
  }
};

export const searchStudents = async (searchString, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(null, "GET", `${STUDENT}/all?searchBy=${searchString}`, {
      Authorization,
    });
  } catch (err) {
    return err;
  }
};

export const addMultipleStudents = async (file, schoolId, token) => {
  const Authorization = `Bearer ${token}`;
  var formData = new FormData();
  formData.append("file", file);
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization,
    },
    data: formData,
    url: `${BASE_URL}/${ADD_STUDENT_CSV}?schoolId=${schoolId}`,
  };
  try {
    const { data } = await axios(options);
    if (data) return data;

    throw new Error("Something went wrong please try again");
  } catch (err) {
    throw new Error(err);
  }
};

export const studentCurrentInvoice = async (studentId, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(
      null,
      "GET",
      `${STUDENT_CURENT_INVOICE}?studentId=${studentId}`,
      { Authorization }
    );
  } catch (err) {
    return err;
  }
};

export const studentGetInvoices = async (studentId, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(
      null,
      "GET",
      `${STUDENT_INVOICES}?studentId=${studentId}`,
      { Authorization }
    );
  } catch (err) {
    return err;
  }
};

export const studentProfileUpload = async (data, id, token) => {
  const Authorization = `Bearer ${token}`;

  const options = {
    method: "POST",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization,
    },
    data: data,
    url: `${BASE_URL}/${UPLOAD_STUDENT_PROFILE_PIC}?studentId=${id}`,
  };
  try {
    const { data } = await axios(options);
    if (data) return data;

    throw new Error("Something went wrong please try again");
  } catch (err) {
    throw new Error(err);
  }
};

export const getStudentBalance = async (studentId, token) => {
  // const Authorization = Bearer ${token};
  try {
    return sendRequest(
      null,
      "GET",
      `${GET_STUDENT_BALANCE}?studentId=${studentId}`
      // { Authorization }
    );
  } catch (err) {
    return err;
  }
};

export const getStudentTransactions = async (studentId, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(
      null,
      "GET",
      `${GET_STUDENT_TRANSACTIONS}?studentId=${studentId}`,
      { Authorization }
    );
  } catch (err) {
    return err;
  }
};

export const updateMultipleStudents = async (file, schoolId, token) => {
  const Authorization = `Bearer ${token}`;
  var formData = new FormData();
  formData.append("file", file);
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization,
    },
    data: formData,
    url: `${BASE_URL}/${UPDATE_STUDENT_CSV}?schoolId=${schoolId}`,
  };
  try {
    const { data } = await axios(options);
    if (data) return data;

    throw new Error("Something went wrong please try again");
  } catch (err) {
    throw new Error(err);
  }
};

export const fetchPayeeData = async (payeeId, payeeType, schoolId) => {
  try {
    return sendRequest(
      null,
      "GET",
      `paymentOnly/searchByPayeeId?payeeId=${payeeId}&payeeType=${payeeType}&schoolId=${schoolId}`,
      {}
    );
  } catch (err) {
    return err;
  }
};

export const initiateTransactionForPayment = async (
  orderId,
  amount,
  schoolId
) => {
  try {
    return sendRequest(
      null,
      "GET",
      `transaction/initiatePayment?orderId=${orderId}&amount=${amount}&schoolId=${schoolId}&isPaymentLink=true`,
      {}
    );
  } catch (err) {
    return err;
  }
};

export const createTransactionForPayment = async (data, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(data, "POST", `paymentOnly/createCbdPayment`, {
      Authorization,
    });
  } catch (err) {
    return err;
  }
};

export const createTransactionForTicket = async (data, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(data, "POST", `paymentOnly/createTicketTransaction`, {
      Authorization,
    });
  } catch (err) {
    return err;
  }
};
